// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/unserviceable-elt-relief.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/unserviceable-elt-relief/unserviceable-elt-relief.js';

mount([g0]);
